import React from "react";
import BasePhoneNumber from "../BasePhoneNumber";
import { makeStyles } from "../../hooks/make-styles-wrapper";

const useStyles = makeStyles(
    (theme, overrides, merge) => ({
        phoneWidth: merge(
            {
                width: "400px",
                "& label.Mui-focused": {
                    color: theme.palette.primary.main,
                },
                "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                        borderColor: theme.palette.grey.dark,
                    },
                    "&.Mui-focused fieldset": {
                        borderColor: theme.palette.primary.main,
                    },
                },

                [theme.breakpoints.down(350)]: {
                    width: "280px",
                },
                [theme.breakpoints.between(350, 400)]: {
                    width: "320px",
                },
                [theme.breakpoints.between(400, 500)]: {
                    width: "350px",
                },
                [theme.breakpoints.up(500)]: {
                    width: "400px",
                },
            },
            overrides,
        ),
    }),
    "textInput.chat",
);

const PhoneNumber = (props) => {
    const styles = useStyles();
    return (
        <BasePhoneNumber
            className={styles.phoneWidth}
            {...props}
        />
    );
};

export default PhoneNumber;
